import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import {
    Box,
    Grid,
    Rating,
    styled,
    Typography,
    Button,
    Paper,
    Alert,
} from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import kidsSmile from '../assets/KidsClassroomMed.jpg';
import teacherImage from '../assets/teacher.jpg';
import BookingSummaryGrid from '../components/BasicComponents/BookingSummaryGrid';
import HomePageTopSection from '../components/BasicComponents/HomePageTopSection';
import BookingSummary from '../components/BookingInfo/BookingSummary';
import Loading from '../components/Loading';
import { fetchQuickBooking, fetchTeacherBooking } from '../redux/BookingSlice';
import { PieChart } from '@mui/x-charts';
import axios from 'axios';
import splitCamelCaseToString from '../utils/titleCase';

const MainBox = styled(Box)(({ theme }) => ({
    m: 2,
    maxWidth: '800px',
    width: '100%',
    [theme.breakpoints.only('sm')]: {
        // maxWidth: '610px',
    },
    [theme.breakpoints.up('sm')]: {
        minWidth: '610px',
    },
}));

const LocalBookingBox = styled(Box)(({ theme }) => ({
    marginTop: '24px',
    m: 2,
    width: '100%',
    // [theme.breakpoints.only('sm')]: {
    //     maxWidth: '800px',
    // },
    [theme.breakpoints.up('sm')]: {
        maxWidth: '800px',
    },
}));

const BookingButton = styled(Button)(({ theme }) => ({
    padding: '10px',
    margin: '10px auto',
    borderRadius: '30px',
}));

const LightPaper = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.third.light,
    padding: '15px',
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: '1rem',
    margin: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:hover, &:focus': {
        cursor: 'pointer',
        boxShadow:
            '0px 7px 8px -4px rgba(0,0,0,0.2), 0px 12px 17px 2px rgba(0,0,0,0.14), 0px 5px 22px 4px rgba(0,0,0,0.12)',
    },
    [theme.breakpoints.down('sm')]: {
        margin: '2rem .3rem',
    },
    [theme.breakpoints.up('sm')]: {
        maxWidth: '35rem',
        margin: '2rem auto',
    },
}));

export const TeacherHome = () => {
    const profile = useSelector(state => state.profile);
    const token = useSelector(state => state.token.token);

    const { booking, quickBooking } = useSelector(state => state.booking);
    const bookingStatus = useSelector(state => state.booking.status);
    const quickBookingStatus = useSelector(state => state.booking.quickStatus);
    const tokenStatus = useSelector(state => state.token.status);
    const dispatch = useDispatch();

    const history = useHistory();

    const { getAccessTokenSilently } = useAuth0();

    console.log('Profile', profile);

    const blue = ['blue'];
    const orange = ['orange'];
    const green = ['green'];
    const requestPushNotifications = () => {
        const token = getAccessTokenSilently({
            scope: process.env.REACT_APP_scope,
        })
            .then(token => {
                axios
                    .get('/notifications', {
                        baseURL: process.env.REACT_APP_API_GATEWAY,
                        timeout: 15000,
                        headers: {
                            authorization: `Bearer ${token}`,
                            'Content-Type': document.type,
                        },
                    })
                    .then(publicKey => {
                        function urlBase64ToUint8Array(base64String) {
                            console.log(
                                `Recieved Key: ${base64String} which is type of ${typeof base64String}`
                            );
                            const padding = '='.repeat(
                                (4 - (base64String.length % 4)) % 4
                            );
                            const base64 = (base64String + padding)
                                .replace(/\-/g, '+')
                                .replace(/_/g, '/');

                            const rawData = window.atob(base64);
                            const outputArray = new Uint8Array(rawData.length); // Corrected this line

                            for (let i = 0; i < rawData.length; ++i) {
                                // Corrected this line
                                outputArray[i] = rawData.charCodeAt(i); // Corrected this line
                            }
                            return outputArray;
                        }

                        const newBase64Key = urlBase64ToUint8Array(
                            publicKey.data.VAPIDpublicKey
                        );

                        navigator.serviceWorker.ready.then(
                            async ServiceWorkerRegistration => {
                                const options = {
                                    userVisibleOnly: true,
                                    applicationServerKey: newBase64Key,
                                };
                                ServiceWorkerRegistration.pushManager
                                    .subscribe(options)
                                    .then(async pushSubscription => {
                                        // The push subscription details needed by the application
                                        // server are now available, and can be sent to it using,
                                        // for example, an XMLHttpRequest.

                                        const params = {
                                            subscriptionInfo: pushSubscription,
                                        };
                                        await axios
                                            .post('/notifications', params, {
                                                baseURL:
                                                    process.env
                                                        .REACT_APP_API_GATEWAY,
                                                timeout: 15000,
                                                headers: {
                                                    authorization: `Bearer ${token}`,
                                                    'Content-Type':
                                                        document.type,
                                                },
                                            })
                                            .catch(err => {
                                                ServiceWorkerRegistration.pushManager.unregister();
                                                console.log(
                                                    'Failed to send subscription info ',
                                                    err
                                                );
                                            });
                                    })
                                    .catch(error => {
                                        // During development it often helps to log errors to the
                                        // console. In a production environment it might make sense to
                                        // also report information about errors back to the
                                        // application server.
                                        console.error('Error with subscribe');
                                        console.error(error);
                                    });
                            }
                        );
                    })
                    .catch(err => {
                        console.log('Failed to get public key ', err);
                    });
            })
            .catch(err => {
                console.log('Failed to get token ', err);
            });
    };

    useEffect(() => {
        //Get the latest booking information on the home page
        console.log(JSON.stringify(profile.profile));
        if (profile.profile.Data.Count > 0) {
            if (
                profile.profile.Data.Items[0].type === 'Teacher' &&
                bookingStatus === 'idle'
            ) {
                async function dispatchBookingFromStore() {
                    const tokenItem = await getAccessTokenSilently({
                        scope: process.env.REACT_APP_scope,
                    });
                    dispatch(
                        fetchTeacherBooking({
                            token: tokenItem,
                            status1: 'Pending',
                            status2: 'Approved',
                            location: 'Home',
                        })
                    );
                }
                dispatchBookingFromStore();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookingStatus]);

    useEffect(() => {
        //Get the latest quick booking information on the home page
        console.log(JSON.stringify(profile.profile));
        if (profile.profile.Data.Count > 0) {
            if (
                profile.profile.Data.Items[0].type === 'Teacher' &&
                quickBookingStatus === 'idle'
            ) {
                async function dispatchQBookingFromStore() {
                    const token = await getAccessTokenSilently({
                        scope: process.env.REACT_APP_scope,
                    });
                    dispatch(fetchQuickBooking({ token: token }));
                }
                dispatchQBookingFromStore();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quickBookingStatus]);

    return (
        <div>
            {tokenStatus === 'succeeded' && (
                <HomePageTopSection
                    location="/teacher-availability"
                    title="Manage Availability"
                    buttonTitle="Manage Availability"
                    textColor="#FFF"
                    smallImage={teacherImage}
                    largeImage={kidsSmile}
                    verified={token.permissions.find(
                        perm => perm === 'create:availability'
                    )}
                />
            )}

            {profile.profile.Data.Count > 0 &&
            profile.profile.Data.Items[0].verified === 'true' ? (
                <>
                    {/* <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            // paddingTop: '40px',
                        }}
                    >
                        <StyledPaper
                            elevation={3}
                            sx={{ width: '250px', textAlign: 'center' }}
                            onClick={requestPushNotifications}
                        >
                            Register for push
                        </StyledPaper>
                    </Box> */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            paddingTop: '10px',
                        }}
                    >
                        {/* {typeof profile.profile.Data.Items[0].rating !==
                            'undefined' && ( */}
                        <>
                            <MainBox
                                sx={{
                                    // backgroundColor: '#FFF',
                                    borderRadius: '5px',
                                    // boxShadow:
                                    //     '1px 1px 9px -2px rgb(0 0 0 / 20%)',
                                }}
                            >
                                <Grid container spacing={2} marginTop={5}>
                                    <Grid item xs={12} md={7}>
                                        <Box
                                            sx={{
                                                // background: '#fff',
                                                // width: '50%',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                paddingRight: '1.5rem',
                                                paddingBottom: '.4rem',
                                                margin: '0 auto',
                                                borderRadius: '5px',
                                                height: '200px',
                                                position: 'relative',
                                                marginTop: '-30px',
                                            }}
                                        >
                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    width: '100%',
                                                    background: '#fff',
                                                    maxWidth: '800px',
                                                    height: '105px',
                                                    borderRadius: 15,
                                                    bottom: 25,
                                                }}
                                            ></span>
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    height: 100,
                                                    width: 100,
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        transform:
                                                            'translate(-55%,-65%)',
                                                        textAlign: 'center',
                                                        background:
                                                            'rgb(233,233,233)',
                                                        width: '110px',
                                                        height: '108px',
                                                        borderRadius: '50%',
                                                        top: '90%',
                                                        left: '100%',
                                                    }}
                                                >
                                                    <img
                                                        src={
                                                            profile.profile.Data
                                                                .Items[0]
                                                                .profileImage
                                                        }
                                                        alt={`${profile.profile.Data.Items[0].firstName}`}
                                                        style={{
                                                            width: '100%',
                                                            position:
                                                                'absolute',
                                                            marginLeft: '-55px',
                                                            borderRadius: '50%',
                                                        }}
                                                    />
                                                </div>

                                                <PieChart
                                                    sx={
                                                        {
                                                            // marginTop: '-81px !important',
                                                        }
                                                    }
                                                    colors={
                                                        profile.profile.Data
                                                            .Items[0].rating >
                                                        4.0
                                                            ? green
                                                            : profile.profile
                                                                  .Data.Items[0]
                                                                  .rating > 2.5
                                                            ? blue
                                                            : orange
                                                    }
                                                    series={[
                                                        {
                                                            data: [
                                                                {
                                                                    id: 0,
                                                                    value: profile
                                                                        .profile
                                                                        .Data
                                                                        .Items[0]
                                                                        .rating,
                                                                },
                                                            ],
                                                            innerRadius: 55,
                                                            outerRadius: 75,
                                                            paddingAngle: 0.5,
                                                            cornerRadius: 15,
                                                            startAngle:
                                                                360 -
                                                                (profile.profile
                                                                    .Data
                                                                    .Items[0]
                                                                    .rating /
                                                                    5.0) *
                                                                    360,
                                                            endAngle: 360,
                                                            cx: 90,
                                                            cy: 70,
                                                        },
                                                    ]}
                                                    overflow="scroll"
                                                    width={300}
                                                    height={300}
                                                />
                                            </div>
                                            {profile.profile.Data.Items[0]
                                                .firstName && (
                                                <>
                                                    <Typography
                                                        sx={{
                                                            color: 'black',
                                                            zIndex: '10',
                                                            marginLeft: '13rem',
                                                            position:
                                                                'absolute',
                                                        }}
                                                    >
                                                        {`${splitCamelCaseToString(
                                                            profile.profile.Data
                                                                .Items[0]
                                                                .firstName
                                                        )} ${splitCamelCaseToString(
                                                            profile.profile.Data
                                                                .Items[0]
                                                                .lastName
                                                        )}`}
                                                    </Typography>
                                                </>
                                            )}
                                            {profile.profile.Data.Items[0]
                                                .rating && (
                                                <>
                                                    <Typography
                                                        variant="h5"
                                                        sx={{
                                                            fontWeight: '600',
                                                            fontSize: '3rem',
                                                            marginTop: '85px',
                                                            marginLeft:
                                                                '11.5rem',
                                                            zIndex: '1',
                                                            position:
                                                                'absolute',
                                                        }}
                                                    >
                                                        {
                                                            profile.profile.Data
                                                                .Items[0].rating
                                                        }
                                                    </Typography>
                                                    <Rating
                                                        sx={{
                                                            alignSelf:
                                                                'space-between',
                                                            marginTop: '65px',
                                                            marginLeft:
                                                                '16.2rem',
                                                            position:
                                                                'absolute',
                                                        }}
                                                        name="simple-controlled"
                                                        value={
                                                            profile.profile.Data
                                                                .Items[0].rating
                                                        }
                                                        size="medium"
                                                        precision={0.5}
                                                        color="primary"
                                                        disabled
                                                    />
                                                    <Typography
                                                        sx={{
                                                            zIndex: '10',
                                                            marginLeft:
                                                                '16.8rem',
                                                            position:
                                                                'absolute',
                                                            marginTop: '110px',
                                                            fontSize: '0.9rem',
                                                            color: '#626b74',
                                                        }}
                                                    >
                                                        {`${profile.profile.Data.Items[0].amountOfRatings} reviews`}
                                                    </Typography>
                                                </>
                                            )}
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={5}>
                                        <Box
                                            sx={{
                                                // background: '#fff',
                                                // width: '50%',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                paddingRight: '1.5rem',
                                                paddingBottom: '.4rem',
                                                margin: '0 auto',
                                                borderRadius: '5px',
                                                height: '200px',
                                                position: 'relative',
                                                marginTop: '-30px',
                                            }}
                                        >
                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    width: '100%',
                                                    background: '#fff',
                                                    maxWidth: '800px',
                                                    height: '105px',
                                                    borderRadius: 15,
                                                    bottom: 25,
                                                }}
                                            >
                                                <Typography
                                                    variant="h6"
                                                    sx={{
                                                        padding: '8px',
                                                        color: '#155979',
                                                        fontSize: '.9rem',
                                                        fontWeight: '600',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    Booking summary
                                                </Typography>
                                                <span
                                                    style={{
                                                        maxWidth: '250px',
                                                        margin: '0px auto',
                                                        display: 'flex',
                                                        justifyContent:
                                                            'space-between',
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            color: '#626b74',
                                                            paddingLeft: '8px',
                                                            fontSize: '0.9rem',
                                                            py: '5px',
                                                        }}
                                                    >
                                                        Bookings to Approve
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            color: '#626b74',
                                                            paddingLeft: '8px',
                                                            fontSize: '0.9rem',
                                                            py: '5px',
                                                            fontWeight: '600',
                                                        }}
                                                    >
                                                        {
                                                            booking.Data.filter(
                                                                item =>
                                                                    item.status ===
                                                                        'Pending' &&
                                                                    new Date(
                                                                        item.endDate
                                                                    ) >
                                                                        new Date()
                                                            ).length
                                                        }
                                                    </Typography>
                                                </span>
                                                <span
                                                    style={{
                                                        maxWidth: '250px',
                                                        margin: '0px auto',
                                                        display: 'flex',
                                                        justifyContent:
                                                            'space-between',
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            color: '#626b74',
                                                            paddingLeft: '8px',
                                                            fontSize: '0.9rem',
                                                            py: '5px',
                                                        }}
                                                    >
                                                        Upcoming Shifts
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            color: '#626b74',
                                                            paddingLeft: '8px',
                                                            fontSize: '0.9rem',
                                                            py: '5px',
                                                            fontWeight: '600',
                                                        }}
                                                    >
                                                        {
                                                            booking.Data.filter(
                                                                item =>
                                                                    item.status ===
                                                                        'Approved' &&
                                                                    new Date(
                                                                        item.endDate
                                                                    ) >
                                                                        new Date()
                                                            ).length
                                                        }
                                                    </Typography>
                                                </span>
                                            </span>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </MainBox>
                        </>
                        {/* )} */}
                    </Box>
                    <Grid
                        container
                        directon="row"
                        justifyContent="space-around"
                        alignItems="top"
                        className="hero"
                    >
                        {quickBookingStatus !== 'failed' && (
                            <LocalBookingBox sx={{ width: '100%' }}>
                                <Grid item xs={12}>
                                    <BookingSummary
                                        title="Available Local Bookings"
                                        subtitle="Bookings available by near by schools"
                                        type="Teacher"
                                        booking={quickBooking.Data}
                                        status="Pending"
                                        status2="Processing"
                                        profileType={
                                            profile.profile.Data.Items[0].type
                                        }
                                        showStatus={true}
                                        loading={
                                            quickBookingStatus !== 'succeeded'
                                        }
                                    ></BookingSummary>
                                </Grid>
                            </LocalBookingBox>
                        )}
                    </Grid>

                    <BookingSummaryGrid
                        Grid1={{
                            title: 'Bookings to Approve',
                            subtitle:
                                'Below are a list of schools who have booked you on your available days. Please approve or decline these bookings.',
                            type: 'awaiting approvals',
                            status: 'Pending',
                            status2: 'Processing',
                            profileType: profile.profile.Data.Items[0].type,
                            showTime: true,
                        }}
                        Grid2={{
                            title: 'Upcoming Shifts',
                            subtitle:
                                'When you have shift bookings this section lets you know the most recent ones coming up so you can see them at a glance',
                            type: 'upcoming bookings',
                            status: 'Approved',
                            profileType: profile.profile.Data.Items[0].type,
                            showTime: true,
                        }}
                        Grid3={{
                            title: 'Ratings Required',
                            subtitle:
                                'This section contains a list of bookings that have finished and require your rating and comments',
                            type: 'upcoming bookings',
                            status: 'Completed',
                            status2: 'Completed',
                            profileType: profile.profile.Data.Items[0].type,
                            showStatus: true,
                        }}
                        booking={booking.Data}
                        loading={bookingStatus !== 'succeeded'}
                    />
                    <br />
                    <br />
                    <Grid
                        container
                        directon="row"
                        // sx={{ m: 1 }}
                        alignItems="flex-end"
                        className="home-teacher-footer"
                    ></Grid>
                </>
            ) : profile.profile.Data.Items[0].verified === 'DocsUploaded' ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        paddingTop: '120px',
                    }}
                >
                    <LightPaper>
                        <Alert severity="info" sx={{ marginBottom: '30px' }}>
                            Waiting on Profile Verification
                        </Alert>
                        <Typography variant="body">
                            This can take up to 24 hours, we will email you when
                            your profile is verified and ready to use.
                        </Typography>
                    </LightPaper>
                </Box>
            ) : (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        paddingTop: '120px',
                    }}
                >
                    <BookingButton
                        variant="outlined"
                        color="primary"
                        component="span"
                        onClick={e => {
                            history.push('/profile/skills');
                        }}
                    >
                        Register as a Teacher on airTeachr
                    </BookingButton>
                </Box>
            )}
        </div>
    );
};

export default withAuthenticationRequired(TeacherHome, {
    onRedirecting: () => <Loading />,
});
